import type {
  OidcManager
} from '@rhitm-incubator/oidc-manager';

/**
 * A promise that indicates if the oidcManager
 * singleton is available.
 */
export const oidcManagerResolved: Promise<OidcManager> = new Promise(res => {
  if (window.oidcManager) { return res(window.oidcManager); }
  window.addEventListener('oidc-manager-registered', () => {
    res(window.oidcManager);
  }, { once: true });
});
